// extracted by mini-css-extract-plugin
module.exports = {"settingsMeasurementsWrapper":"SettingsMeasurementsWrapper_settingsMeasurementsWrapper__2-NO5"};